import { css, cva } from '@/styled-system/css';

// Design Specs: https://www.figma.com/file/2UlxeTUdKRMOHjl0h3rOg1/Starter-File-Multi-Step-Forms-AKA-Wizards?node-id=119%3A24517

export const wizardFormStyles = css.raw({
  flexGrow: 2,
});

export const wizardHeadingStyles = css.raw({
  display: 'block',
  marginBottom: '400',
});

export const wizardParagraphStyles = css.raw({
  display: 'block',
  marginBottom: '600',
});

export const wizardFormSectionContainerStyles = cva({
  base: {
    marginBottom: '800',

    '&:last-child': {
      marginBottom: '600',
    },
  },
  variants: {
    isInMultiplexListingFlow: {
      true: {
        width: '100%',
        maxWidth: '100%',
      },
      false: {
        width: { base: '100%', xxl: '656px' },
      },
    },
  },
  defaultVariants: {
    isInMultiplexListingFlow: false,
  },
});

export const wizardFlexContainerStyles = css.raw({
  display: 'flex',
  flexDirection: { base: 'column', xxl: 'row' },
  justifyContent: 'space-between',
});

export const wizardLabeledControlStyles = css.raw({
  minWidth: '50%',
});

// Hacky fix for the tip card on wizard pages being aligned slightly left of the ones on other form pages.
export const wizardTipCardLeftSpacingStyles = css.raw({
  marginLeft: { xxl: '19.5px' },
});

export const wizardGridContainerStyles = css.raw({
  display: 'grid',
  gridTemplateColumns: {
    base: 'repeat(6, 1fr)',
    lg: 'repeat(12, 1fr)',
  },
  gap: '400',
});

export const wizardFormColumnStyles = css.raw({
  gridColumnEnd: { base: 'span 6', lg: 'span 12', xl: 'span 7' },
});

export const wizardTipCardColumnStyles = css.raw({
  gridColumnEnd: { base: 'span 6', lg: 'span 12', xxl: 'span 5' },
});
